import { logger } from 'cadenza/utils/logging';

export function showGeometryFilteringDialog (map, layerId, geometries, submitCallback) {
  let dialog;
  return import(/* webpackChunkName: "geometry-filtering-dialog" */ './geometry-filtering-dialog')
    .then(({ GeometryFilteringDialog }) => {
      dialog = new GeometryFilteringDialog(map, layerId, geometries);
      dialog.onSubmit = () => {
        submitCallback();
      };
      document.body.appendChild(dialog);
      return dialog.showModal();
    })
    .then(() => dialog.remove())
    .catch(error => {
      logger.error('Failed to import module geometry-filtering-dialog.', error);
    });
}
